import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class CrmContact extends ApiBase {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/crm/contact`)
  }

  respond(id, model, showProgress) {
    return this._request({
      action: `${ id }/respond`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
